<template>
  <v-layout>
    <d-header :actions="actions" fluid>
      <h1 class="title">
        {{ $t("users") }}
      </h1>
    </d-header>
    <v-user-list />
  </v-layout>
</template>

<script>
import list from "./_list.vue";

export default {
  metaInfo() {
    return {
      title: this.$t("users"),
    };
  },
  components: {
    "v-user-list": list,
  },
  computed: {
    actions() {
      let actions = [];
      if (this.$laravel.user.permissions["user-create"]) {
        actions.push({
          action: () => {
            this.$router.push("/users/create");
          },
          resource: "user",
          method: "create",
          label: this.$t("new_user"),
          primary: true,
          color: "is-primary",
        });
      }
      return actions;
    },
  },
};
</script>
